import { inject } from 'vue';
import { ApiPlugin } from '@/plugins';

export default class Doctor {
  static getDoctorPageContent() {
    const placeNid = inject('place-nid');
    const data = {
      ...window?.drupalSettings?.['same-address-page']?.[placeNid],
      name: window?.drupalSettings?.['same-address-page']?.professionalTitle,
      rpps: window?.drupalSettings?.['same-address-page']?.professionalRpps,
      adeli: window?.drupalSettings?.['same-address-page']?.professionalAdeli,
    };

    if (!data) {
      console.error('Could not find the data in window.API matching the place-nid provided by the placeholder.');
      return {};
    }
    return data;
  }

  static getDoctorAppointements() {
    const placeNid = inject('place-nid');
    const data = window?.drupalSettings?.directory_hours_bloc?.[placeNid];
    if (!data) {
      console.error('Could not find the data in window.API matching the place-nid provided by the placeholder.');
      return {};
    }
    return data;
  }

  static async getByGeoloc(latitude, longitude, excludedId, excludedRpps, excludedAdeli) {
    try {
      if (!latitude || !longitude) throw new Error('Function "getByGeoloc" requires latitude and longitude');
      const response = await ApiPlugin.get(
        '/sante_health_pro/get_same_address',
        {
          params: {
            latitude,
            longitude,
            excluded_nid: excludedId,
            excluded_rpps: excludedRpps,
            excluded_adeli: excludedAdeli,
          },
        },
      );
      return response.data;
    } catch (e) {
      console.error('Error fetching getResults \n', e);
      return [];
    }
  }
}
